import EasyActions from './EasyActions';

export default EasyActions;
